import { useState, useEffect } from 'react'

const DEFAULTS = {
  form_enabled: true,
  form_closed_message: 'النموذج مغلق مؤقتاً.',
  form_notice: null,
  tracking_enabled: true,
  bulk_import_enabled: true,
  platform_name: 'المنصة الوطنية لتوثيق شهداء ومفقودي الثورة السورية المباركة',
  platform_tagline: 'حفظاً للذاكرة، وإحقاقاً للحق',
}

const CACHE_KEY = '_pub_settings'
const CACHE_TTL = 60_000 // 1 minute

export function usePublicSettings() {
  const [settings, setSettings] = useState(() => {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY)
      if (raw) {
        const { data, ts } = JSON.parse(raw)
        if (Date.now() - ts < CACHE_TTL) return { ...DEFAULTS, ...data }
      }
    } catch { /* ignore */ }
    return null
  })
  const [loading, setLoading] = useState(settings === null)

  useEffect(() => {
    if (settings !== null) return
    fetch('/api/v1/admin/public-settings')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        const merged = { ...DEFAULTS, ...data }
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: merged, ts: Date.now() }))
        } catch { /* storage full */ }
        setSettings(merged)
      })
      .catch(() => setSettings({ ...DEFAULTS }))
      .finally(() => setLoading(false))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { settings: settings || DEFAULTS, loading: loading && settings === null }
}
